import useTheme from "../../components/muiComponents/core/useTheme";

const useThemeCommon = () => {
    const {palette: {mode, common: {black, white}}} = useTheme();
    return mode === "dark" ? black : white;
}

export default useThemeCommon;